import type { ElplanInfoTagForDate } from 'api/elplan/elplan.types'
import type { DayAheadBidTagDomainIssue } from './DayAheadBidTable.types'

export function getDayAheadBidTagDomainIssues(
  displayTagsForDate: ElplanInfoTagForDate[],
  configuredTagsForDate: ElplanInfoTagForDate[]
): DayAheadBidTagDomainIssue[] {
  const issues: DayAheadBidTagDomainIssue[] = []
  const configuredById = new Map<number, ElplanInfoTagForDate>()
  const displayIds = new Set<number>()

  for (const tag of configuredTagsForDate) {
    if (configuredById.has(tag.id)) {
      issues.push({ kind: 'duplicate-configured-tag', tagId: tag.id })
      continue
    }
    configuredById.set(tag.id, tag)
  }

  for (const tag of displayTagsForDate) {
    if (displayIds.has(tag.id)) {
      issues.push({ kind: 'duplicate-display-tag', tagId: tag.id })
      continue
    }
    displayIds.add(tag.id)

    const configuredTag = configuredById.get(tag.id)
    if (!configuredTag) {
      issues.push({ kind: 'display-tag-not-configured', tagId: tag.id })
      continue
    }

    if (
      configuredTag.tag_key !== tag.tag_key ||
      configuredTag.buy_sell !== tag.buy_sell ||
      configuredTag.production_consumption !== tag.production_consumption
    ) {
      issues.push({ kind: 'tag-metadata-mismatch', tagId: tag.id })
    }
  }

  return issues
}
